import isEqual from "lodash/isEqual";
import { OrderOption, OrderOptionOrEmpty } from "PFTypes/meta";

export const PLANNER_ORDER_TARGET = "capacity_index" as const;

export const PLANNER_ORDER_NAME = ["available_minutes"] as const;

export const PLANNER_ORDER_DIRECTION = "desc";

export const PLANNER_ORDER_TEXT = "Available minutes desc";

export const isValidPlannerOrder = (order: OrderOptionOrEmpty | undefined): order is OrderOption =>
  !!order &&
  "name" in order &&
  isEqual(order.name, PLANNER_ORDER_NAME) &&
  !!order.start_date &&
  !!order.end_date;
